import type { GetDriverOrderChangesQuery } from '@/generated/graphql/graphql';

export type OrderChange = GetDriverOrderChangesQuery['order_change'][number];

interface OrderChangeStateFields {
  statusName: string | null;
}

function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === 'object' && value !== null && !Array.isArray(value);
}

function parseStateFields(value: unknown): OrderChangeStateFields {
  if (!isRecord(value)) {
    return { statusName: null };
  }
  const statusName = value.statusName;
  return {
    statusName: typeof statusName === 'string' ? statusName : null,
  };
}

export function getOrderChangeStatusName(change: OrderChange): string {
  return parseStateFields(change.new).statusName ?? '';
}
